import './scss/sidebar.scss'
import {Component, ScrollPane, TabbedPane} from 'substance'

class DWSidebar extends Component {

    constructor(...args) {
        super(...args)

        this.barComponentRegistry = this.context.configurator.barComponentRegistry

        this.handleActions({
            switchTab: this.switchContext
        })
    }

    getInitialState() {

        const tabId = this.activeTabId()

        return {
            tabId
        }
    }

    switchContext(tabId) {

        this.context.appStorage.set(
            'dw.sidebar',
            'tabId',
            tabId
        )

        this.extendState({
            tabId
        })
    }

    render($$) {

        const tabOrder = this.context.configurator.getWriterConfigValue('tabOrder', [])

        return $$('div')
            .addClass('dwc-context-section')
            .append(
                $$(ScrollPane, {
                    scrollbarType: 'native',
                    scrollbarPosition: 'left'
                }).append([
                    $$(TabbedPane, {
                        activeTab: this.state.tabId,
                        tabs: this.barComponentRegistry.getOrderedSideBars(tabOrder)
                    }).append(
                        this.getSidebarPanelsForTabId($$, this.state.tabId)
                    )
                ])
            )
    }

    /**
     * Get all registered sidebar panels and then filter by the current tab id
     *
     * @param $$
     * @param tabId
     * @returns {Array} - Returns an array with components
     */
    getSidebarPanelsForTabId($$, tabId) {
        return this.context.configurator.getSidebarPanels()
            .filter(plugin => plugin.tabId === tabId)
            .map(plugin => {
                return $$('div')
                    .addClass(`plugin plugin-${plugin.getCSSFriendlyName()}`)
                    .append($$(plugin.component, {pluginConfigObject: plugin}))
            })
    }

    /**
     * Find current active tab using Storage, will default to 'main'
     * if active tab is not found, or the active tab does not exist in
     * registered tabs
     *
     * @returns {string}
     */
    activeTabId() {
        const defaultTabId = 'main'
        const tabIds = this.getSidebarIds()

        const tabId = this.context.appStorage.get(
            'dw.sidebar',
            'tabId',
            defaultTabId
        )

        return tabIds.includes(tabId) ? tabId : defaultTabId
    }

    /**
     * Returns ids for all registered sidebar tabs
     *
     * @returns {string[]}
     */
    getSidebarIds() {
        return this.context.configurator.barComponentRegistry.getSideBars().map((sidebar) => {
            return sidebar.id
        })
    }
}

export {DWSidebar}
